let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("zjABI")).then(() => parcelRequire('52F2e'));